"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Balance = exports.BalanceUpdateEvent = exports.BalanceStatus = void 0;
const utils_1 = require("../../utils");
var BalanceStatus;
(function (BalanceStatus) {
    BalanceStatus["Updating"] = "Updating";
    BalanceStatus["Done"] = "Done";
})(BalanceStatus || (exports.BalanceStatus = BalanceStatus = {}));
class BalanceUpdateEvent {
    previousValue;
    value = BigInt(0);
    constructor(previousValue) {
        this.previousValue = previousValue;
    }
}
exports.BalanceUpdateEvent = BalanceUpdateEvent;
// 30 seconds between updates
const UpdateTimeValidity = BigInt(30);
class Balance {
    listeners = [];
    lastUpdate = BigInt(0);
    status = BalanceStatus.Done;
    value = BigInt(0);
    registerEvents(listener) {
        this.listeners.push(listener);
    }
    update(value) {
        if (this.status === BalanceStatus.Updating) {
            return;
        }
        this.status = BalanceStatus.Updating;
        const event = new BalanceUpdateEvent(this.value);
        this.value = value;
        this.status = BalanceStatus.Done;
        event.value = value;
        this.callBalanceUpdateEvent(event);
    }
    async updateAsync(fetch) {
        if (this.status === BalanceStatus.Updating) {
            return;
        }
        this.status = BalanceStatus.Updating;
        const event = new BalanceUpdateEvent(this.value);
        this.value = await fetch;
        this.status = BalanceStatus.Done;
        event.value = this.value;
        this.callBalanceUpdateEvent(event);
    }
    shouldUpdate() {
        return utils_1.TimeUtils.now() < this.lastUpdate + UpdateTimeValidity;
    }
    getStatus() {
        return this.status;
    }
    getValue() {
        return this.value;
    }
    spend(value) {
        const event = new BalanceUpdateEvent(this.value);
        this.value -= value;
        event.value = this.value;
        this.callBalanceUpdateEvent(event);
    }
    callBalanceUpdateEvent(event) {
        this.lastUpdate = utils_1.TimeUtils.now();
        this.listeners.forEach((listener) => {
            listener.onBalanceUpdateEvent(event);
        });
    }
}
exports.Balance = Balance;
